export default __webpack_public_path__ + "static/media/hero-02.70b1dcc6.png";